import { Entity } from '@backstage/catalog-model';
import { ChangelogFormat } from './types.ts';
import { conventionalChangelogParser } from './conventionalChangelogParser.ts';
import { semverParser } from '@rsc-labs/backstage-changelog-plugin';

export const CHANGELOG_ANNOTATION_NAME = 'changelog-name';
export const CHANGELOG_FORMAT_ANNOTATION_NAME = 'changelog-format';

export const isChangelogAnnotationConfigurationOk = (
  entity: Entity,
): boolean => {
  return Boolean(entity.metadata.annotations?.[CHANGELOG_ANNOTATION_NAME]);
};

export const getChangelogFormat = (entity: Entity): ChangelogFormat => {
  if (entity.metadata.annotations?.[CHANGELOG_FORMAT_ANNOTATION_NAME]) {
    return entity.metadata.annotations?.[
      CHANGELOG_FORMAT_ANNOTATION_NAME
    ] as ChangelogFormat;
  }
  return 'keep-a-changelog';
};

export const getParser = (entity: Entity) => {
  const format = getChangelogFormat(entity);
  switch (format) {
    case 'conventional-changelog':
      return conventionalChangelogParser;
    case 'semver':
      return semverParser;
    default:
      return undefined;
  }
};

export const isConventionalChangelog = (entity: Entity): boolean => {
  return (
    isChangelogAnnotationConfigurationOk(entity) &&
    getChangelogFormat(entity) === 'conventional-changelog'
  );
};

export const isSemverChangelog = (entity: Entity): boolean => {
  return (
    isChangelogAnnotationConfigurationOk(entity) &&
    getChangelogFormat(entity) === 'semver'
  );
};

export const isKeepAChangelog = (entity: Entity): boolean => {
  return isChangelogAnnotationConfigurationOk(entity);
};
